import { useLeagueContext } from "@/modules/leagues/hooks/useLeagueContext";
import { SettingsSubHeader } from "@/modules/leagues/components/SettingsSubHeader";
import { ScoringRulesEditor } from "@/modules/leagues/components/ScoringRulesEditor";

export function LeagueSettingsScoringPage() {
  const { league } = useLeagueContext();

  return (
    <div className="space-y-4">
      <SettingsSubHeader leagueId={league.id} title="Pontuação" />
      <ScoringRulesEditor rules={league.rules.rules} readOnly frozenAt={league.rules.frozenAt} />
    </div>
  );
}
